module.exports = __webpack_public_path__ + "images/gamification/bronze.svg";